export default __webpack_public_path__ + "static/media/card-2.440078f6.webp";